// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Testimonials_wrapper__jiwFG","wrapperTitle":"Testimonials_wrapperTitle__oK4Xl","cardsWrapper":"Testimonials_cardsWrapper__BSkSs","card":"Testimonials_card__h2MWj"};